import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "w-[500px] bg-white rounded-lg shadow-sm border border-gray-200 p-6" }
const _hoisted_3 = { class: "flex items-center justify-between mb-6" }
const _hoisted_4 = { class: "flex items-center gap-2" }
const _hoisted_5 = { class: "bg-gray-100 text-gray-600 text-sm px-2 py-1 rounded-full" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "space-y-4 max-h-[400px] overflow-y-auto pr-1" }
const _hoisted_8 = { class: "flex items-center mt-1" }
const _hoisted_9 = ["id", "name", "value"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "flex items-center gap-2 mb-1" }
const _hoisted_12 = { class: "font-medium text-sm text-gray-900" }
const _hoisted_13 = { class: "text-sm text-gray-600" }

import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import Api from '@/services/api'

interface TodoAdditionalData {
  year: number
  month: number
  project_id: number
  cost_center: string
  project_title: string
  foreign_establishment_id: number
}

interface Todo {
  id: number
  user: string
  title: string
  content: string
  item_id: number
  completed: boolean
  link_to_action: string
  category: string
  additional_data: TodoAdditionalData
  due_date: string | null
  created_at: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TodosCard',
  props: {
    todos: {}
  },
  emits: ["show-alert"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

const router = useRouter()
const store = useStore()
const selectedTodos = ref<number[]>([])
const marking = ref(false)

const todoActionHandlers: Record<string, (todo: Todo) => void> = {
  '/edit-pm-local': (todo) => {
    const projectTitle = [todo.additional_data?.cost_center, todo.additional_data?.project_title]?.filter(Boolean)?.join(" ")
    store.commit("pmLocalModules/SET_PM_LOCAL_TITLE_STATE", projectTitle);
    if (todo.title === 'Month Locked – Review Required' || todo.title === 'Month Locked - Signature Required') {
      store.commit('pmLocalModules/SET_FOREIGN_ESTABLISH_ID_TO_STATE', todo.additional_data?.foreign_establishment_id)
      store.commit('pmLocalModules/SET_PROJECT_ID_TO_STATE', todo.additional_data?.project_id)
      store.commit('expenseModules/SET_PDF_MONTH_TO_STATE', todo.additional_data?.month)
      store.commit('expenseModules/SET_PDF_YEAR_TO_STATE', todo.additional_data?.year)
      store.commit('expenseModules/SET_PDF_EXPENSE_TYPE_TO_STATE', 'cash')
      router.push({ name: 'viewExpensePdf' })
    } else {
      store.commit('pmLocalModules/SET_PM_LOCAL_ID_STATE', todo.item_id)
      router.push({ name: 'editPmLocal' })
    }
  },
}

function openTodo(todo: Todo) {
  const handler = todoActionHandlers[todo.link_to_action]
  if (handler) handler(todo)
}

async function markSelectedAsDone() {
  if (selectedTodos.value.length === 0) {
    emit('show-alert', { type: 'error', title: 'Please select at least one todo.', state: true })
    return
  }
  marking.value = true
  try {
    const response = await Api().put('/hr/to-dos/mark-as-completed/', {
      ids: selectedTodos.value,
      completed: true,
    })
    if (response.data.status === 'success') {
      emit('show-alert', { type: 'success', title: response.data?.detail, state: true })
      // store.dispatch('auth/getUserHomePage')
      selectedTodos.value = []
    }
  } catch (error: any) {
    emit('show-alert', { type: 'error', title: error?.response?.data?.detail, state: true })
  } finally {
    marking.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "text-lg font-semibold text-gray-900" }, "My Todos", -1)),
          _createElementVNode("span", _hoisted_5, _toDisplayString(__props.todos?.length), 1)
        ]),
        _createElementVNode("button", {
          onClick: markSelectedAsDone,
          disabled: selectedTodos.value.length === 0 || marking.value,
          class: "bg-red-600 hover:bg-red-700 disabled:bg-gray-300 disabled:cursor-not-allowed text-white px-4 py-2 rounded-md text-sm font-medium transition-colors"
        }, " Mark as done ", 8, _hoisted_6)
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.todos, (todo) => {
          return (_openBlock(), _createElementBlock("div", {
            key: todo.id,
            class: "flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors"
          }, [
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                id: `todo-${todo.id}`,
                name: `todo-${todo.id}`,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedTodos).value = $event)),
                value: todo.id,
                type: "checkbox",
                class: "w-4 h-4 text-red-600 bg-gray-100 border-gray-300 rounded focus:ring-red-500 focus:ring-2 disabled:opacity-50 cursor-pointer"
              }, null, 8, _hoisted_9), [
                [_vModelCheckbox, selectedTodos.value]
              ])
            ]),
            _createElementVNode("div", {
              class: "flex-1 min-w-0 cursor-pointer",
              onClick: ($event: any) => (openTodo(todo))
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("h3", _hoisted_12, _toDisplayString(todo.title), 1),
                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-xs text-gray-500" }, "•", -1)),
                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-xs text-gray-500" }, null, -1))
              ]),
              _createElementVNode("p", _hoisted_13, _toDisplayString(todo.content), 1)
            ], 8, _hoisted_10)
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})